module.exports = __webpack_public_path__ + "media/images/advisor/img_7_0-458aefa3d1e521a72cffe1d515580149.png";